import type { GetterTree } from 'vuex'
import type { RootState } from '@/store'
import type { Notification } from '@/types/alerts'
import type { AlertsState } from './types'
import { ALERTS_GETTERS } from './types'

interface IAlertsGetters extends GetterTree<AlertsState, RootState> {
  [ALERTS_GETTERS.GET_NOTIFICATIONS](state: AlertsState): Notification[]
  [ALERTS_GETTERS.GET_NOTIFICATIONS_NUM](state: AlertsState): number
  [ALERTS_GETTERS.GET_NOTIFICATIONS_BY_DEVICE_ID](
    state: AlertsState
  ): (deviceId: string) => Notification[]
  [ALERTS_GETTERS.GET_NOTIFICATIONS_NUM_BY_DEVICE_ID](
    state: AlertsState
  ): (deviceId: string) => number
}

const getters: IAlertsGetters = {
  [ALERTS_GETTERS.GET_NOTIFICATIONS](state) {
    return state.notifications
  },
  [ALERTS_GETTERS.GET_NOTIFICATIONS_NUM](state) {
    return state.notifications.length
  },
  [ALERTS_GETTERS.GET_NOTIFICATIONS_BY_DEVICE_ID](state) {
    return (deviceId: string) =>
      state.notifications.reduce((acc: Notification[], note) => {
        if (note.device.id == deviceId && !note.isRead) {
          acc.push(note)
        }
        return acc
      }, [])
  },
  [ALERTS_GETTERS.GET_NOTIFICATIONS_NUM_BY_DEVICE_ID](state) {
    return (deviceId: string) =>
      state.notifications.reduce((acc: Notification[], note) => {
        if (note.device.id == deviceId && !note.isRead) {
          acc.push(note)
        }
        return acc
      }, []).length
  }
}

export default getters
